import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUI } from '../store/AppContext';
import { canAccessMenu, getFirstAllowedMenu } from '../security/acl';
import { menuIdToPath, pathToMenuId } from './adminRoutes';

const DEFAULT_MENU_ORDER = [
  'dashboard',
  'bookings',
  'broadcasts',
  'vendors',
  'cabs-fleet',
  'cab-revenue',
  'pricing',
  'settings',
];

/**
 * Keeps sidebar activeMenu aligned with the browser URL; redirects when ACL denies the path.
 */
export default function AdminLocationSync({ menuOrder = DEFAULT_MENU_ORDER }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { setActiveMenu, currentUser, sidebar } = useUI();

  useEffect(() => {
    const menuId = pathToMenuId(location.pathname);
    if (!menuId) return;

    if (!canAccessMenu(currentUser, menuId)) {
      const fallback = getFirstAllowedMenu(currentUser, menuOrder);
      const path = menuIdToPath(fallback);
      if (path !== location.pathname) {
        navigate(path, { replace: true });
      }
      setActiveMenu(fallback);
      return;
    }

    if (sidebar.activeMenu !== menuId) {
      setActiveMenu(menuId);
    }
  }, [
    location.pathname,
    currentUser,
    menuOrder,
    navigate,
    setActiveMenu,
    sidebar.activeMenu,
  ]);

  return null;
}
